export const environment = {
  production: false,
  env: 'production',
  apiUrl: 'https://monitorar-backend.mma.gov.br',
  govBrUrl: 'https://sso.acesso.gov.br',
  govBrClientId: 'monitorar.gestor.mma.gov.br',
  govBrSecret: 'Qze8ihdg3LSHLhQbnRr34Qfq2CbHDwopx3_a4rSoCTM4NnEYxd5AzZTNHuORJdJvju-ZqMlz_FNwgPfIrZX4ag',
  govBrRedirectUri: 'https://monitorar-gestor.mma.gov.br/login',
  integradorApiUrl: 'https://integrador-backend-hmg.mma.gov.br',
  integradorApiVersion: 'v1',
  bundleId: 'br.gov.mma.dev.monitorargestao',
  urlAtualizacao: 'https://www.mbamobi.com.br/mma/monitorar/'
};
